// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"471d992c","210":"a1637e12","277":"4a4c2067","400":"44827f52","523":"55a663c4","706":"e83be57c","708":"afd181aa","845":"fda2be14"}[chunkId] + ".chunk.js";
};